<template>
  <div class="home" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="map" id="map"></div>
    <infoWindow
      v-if="infoWindowState"
      class="main"
      ref="main"
      :infoData="infoWindowData"
      @getLocation="navigation"
      @closeWin="closeWin"
    />
    <div v-if="pc" class="menuP">
      <mapMenu
        ref="mapMenuss"
        @getLocation="navigation"
        @checkStore="checkStore"
        @tag="mark"
        :pc="pc"
      />
    </div>
    <div v-else class="menuM">
      <mapMenu
        ref="mapMenuss"
        @tabSwitch="tabSwitch"
        @getLocation="navigation"
        @checkStore="checkStore"
        @tag="mark"
        :pc="pc"
      />
    </div>
  </div>
</template>

<script>
import infoWindow from "@/components/infoWindow";
import mapMenu from "@/components/menu";
import { baiduNavigate } from "@/util/navigation";
import gcoord from 'gcoord';
// import {login} from '@/api'
export default {
  name: "home",
  components: {
    infoWindow,
    // eslint-disable-next-line vue/no-unused-components
    mapMenu,
  },
  data() {
    //坐标系转换  @author qiyulin  @date 2022.10.17
    return {
      ak: "SG5QHevFdltR9YhRGKROKZweA6WqUkT8", // 百度的地图密钥
      myMap: null,
      map: null,
      infoWindowState: false,
      infoWindowData: {},
      pc: true,
      fullscreenLoading: false,
      localInfo:null
    };
  },
  created() {
    if (window.env === 'pc') {
      this.pc = true;
    } else {
      this.pc = false;
    }
  },
  async mounted() {
    // const res = await login()
    // console.log(res)
    // console.log(this._isMobile())
    // var map = new BMap.Map("allmap");
    // 	//			设置中心点坐标
    // var point = new BMap.Point(116.331398, 39.897445);
    // map.centerAndZoom(point, 12);

    // var geolocation = new BMap.Geolocation();
    // geolocation.getCurrentPosition(function(r) {
    // 	if(this.getStatus() == BMAP_STATUS_SUCCESS) {
    // 		var mk = new BMap.Marker(r.point);
    // 		map.addOverlay(mk);
    // 		map.panTo(r.point);
    // 		alert('您的位置：' + r.point.lng + ',' + r.point.lat);
    // 	} else {
    // 		alert('failed' + this.getStatus());
    // 	}
    // });

    await this.init();
    await this.getLocation()
    await this.initMap();
    // await this.mark()
    this.$nextTick(() => {
      if (this.pc) {
        // document.addEventListener("mouseup", this.bodyCloseMenus);
      } else {
        this.map.addEventListener("touchstart", this.bodyCloseMenus);
        // document.getElementById('app').addEventListener("mouseup", this.bodyCloseMenus);
      }
    });
    if (window.env === 'app' || window.env === 'wxApp') {
      document.getElementById('component-id').style.display = 'none'
      document.getElementById('footer').style.display = 'none'
      document.getElementsByClassName('box-div')[0].style.display = 'none'
      document.getElementsByClassName('static-content')[0].style.display = 'none'
      document.getElementsByClassName('static-content')[1].style.display = 'none'
      document.getElementById('app').style.position = 'relative'
      document.getElementById('app').style.top = -(document.getElementById('app').offsetTop)+'px'
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //引入百度地图
    init() {
      //console.log("初始化百度地图脚本...");
      const AK = "B05ff26aff54ee5f38c8ab037dbaf76d";
      const BMap_URL =
        "https://api.map.baidu.com/api?v=2.0&ak=" +
        AK +
        "&s=1&callback=onBMapCallback";
      return new Promise((resolve, reject) => {
        // 如果已加载直接返回
        if (typeof BMap !== "undefined") {
          resolve(BMap);
          return true;
        }
        // 百度地图异步加载回调处理
        window.onBMapCallback = function () {
          console.log("百度地图脚本初始化成功...");
          resolve(BMap);
        };

        // 插入script脚本
        let scriptNode = document.createElement("script");
        scriptNode.setAttribute("type", "text/javascript");
        scriptNode.setAttribute("src", BMap_URL);
        document.body.appendChild(scriptNode);
      });
    },
    //初始化地图
    initMap() {
      const _this = this;
      // 传入密钥获取地图回调。
      // BMPGL(this.ak).then((BMapGL) => {
      // 创建地图实例
      this.map = new BMap.Map("map");
      // 创建点坐标 axios => res 获取的初始化定位坐标
      let point = new BMap.Point(114.031761, 22.542826);
      // 初始化地图，设置中心点坐标和地图级别
      this.map.centerAndZoom(point, 19);
      // this.map.setHeading(64.5)
      // this.map.setTilt(73)
      // 保存数据
      // this.myMap = map
      // this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      var scaleCtrl = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMap.Size(30, 50),
      }); // 添加比例尺控件
      this.map.addControl(scaleCtrl);
      // this.map.addControl(new BMap.NavigationControl());
      let opts = {
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        offset: new BMap.Size(10, 100), //进一步控制缩放按钮的水平竖直偏移量
      };
      this.map.addControl(new BMap.NavigationControl(opts));
    },
    //标注
    mark(datas, type, page,city) {
      const _this = this;
      // console.log(type);
      if (type === 'store' || type === 'store1') {
        let data = datas.map(item => {
          // console.log([_this.localInfo.point.lng, _this.localInfo.point.lat],[Number(item.LONGITUDE),Number(item.LATITUDE)])
          item.km = _this.getDistance([_this.localInfo.point.lng, _this.localInfo.point.lat],[item.longitude,item.latitude])
          return item
        });
        let icon1 = require("../assets/img/icon1.png");
        let icon2 = require("../assets/img/icon2.png");
        var myIcon1 = new BMap.Icon(icon1, new BMap.Size(44, 53), {
          //BMap.Size类表示以指定的宽度和高度创建一个矩形区域大小，有的时候图标太大，Size太小，可能不能显示图标或显示一部分图标
          imageSize: new BMap.Size(44, 53), // 设置显示图像的大小，因为256*256太大，所以可以设置它实际显示的长宽比例为25.6*25.6，相当于缩小十倍了
          anchor: new BMap.Size(13, 13), //标注指向的地理位置距离图标左上角各偏移13和25.6像素(一般宽度是照片宽的一般，长度是照片的长，这样图标的
          //   尖角就能刚好点在坐标点上，否则是图标的中心点在坐标点上)，本例中该位置即是图标中央下端的尖角位置
        });
        var myIcon2 = new BMap.Icon(icon2, new BMap.Size(44, 53), {
          //BMap.Size类表示以指定的宽度和高度创建一个矩形区域大小，有的时候图标太大，Size太小，可能不能显示图标或显示一部分图标
          imageSize: new BMap.Size(44, 53), //设置显示图像的大小，因为256*256太大，所以可以设置它实际显示的长宽比例为25.6*25.6，相当于缩小十倍了
          anchor: new BMap.Size(0, 0), //标注指向的地理位置距离图标左上角各偏移13和25.6像素(一般宽度是照片宽的一般，长度是照片的长，这样图标的
          //   尖角就能刚好点在坐标点上，否则是图标的中心点在坐标点上)，本例中该位置即是图标中央下端的尖角位置
        });
        //清除所有标记
        this.map.clearOverlays()
        data.forEach((item, index) => {
          var label = new BMap.Label(index + 1, {
            offset: new BMap.Size(-8, 10),
          });
          label.setStyle({
            background: "none",
            color: "#666",
            border: "none",
            fontSize: "12px",
            width: "60px",
            textAlign: "center",
            margin: "0",
            padding: "0", //只要对label样式进行设置就可达到在标注图标上显示数字的效果
          });
          let point = new BMap.Point(item.longitude,item.latitude);
          // this.map.centerAndZoom(point, 12);
          let marker = new BMap.Marker(point, {
            icon: item.type===2?myIcon2:myIcon1,
          });
          if(type === 'store1') {
            marker = new BMap.Marker(point, {
            icon: myIcon1,
          });
          }
          marker.setLabel(label);
          marker.addEventListener("click", function () {
            _this.clickEvent(index + 1, item, type);
            _this.buriedPt('ses:list:' + item.name, 'o')
          });
          // marker.editMk = {lng:item.LONGITUDE, lat:item.LATITUDE}
          // console.log(marker,888)
          // 创建标注
          this.map.addOverlay(marker);
        });
      }
      if (type === 'server') {
        let data = datas.map(item => {
          // console.log([_this.localInfo.point.lng, _this.localInfo.point.lat],[Number(item.LONGITUDE),Number(item.LATITUDE)])
          item.km = _this.getDistance([_this.localInfo.point.lng, _this.localInfo.point.lat],[item.longitude,item.LATITUDE])
          return item
        });
      //   console.log(data,666)
        let icon1 = require("../assets/img/icon1.png");
        let icon2 = require("../assets/img/icon2.png");

        var myIcon1 = new BMap.Icon(icon1, new BMap.Size(44, 53), {
          //BMap.Size类表示以指定的宽度和高度创建一个矩形区域大小，有的时候图标太大，Size太小，可能不能显示图标或显示一部分图标
          imageSize: new BMap.Size(44, 53), //设置显示图像的大小，因为256*256太大，所以可以设置它实际显示的长宽比例为25.6*25.6，相当于缩小十倍了
          anchor: new BMap.Size(13, 13), //标注指向的地理位置距离图标左上角各偏移13和25.6像素(一般宽度是照片宽的一般，长度是照片的长，这样图标的
          //   尖角就能刚好点在坐标点上，否则是图标的中心点在坐标点上)，本例中该位置即是图标中央下端的尖角位置
        });
        var myIcon2 = new BMap.Icon(icon2, new BMap.Size(44, 53), {
          //BMap.Size类表示以指定的宽度和高度创建一个矩形区域大小，有的时候图标太大，Size太小，可能不能显示图标或显示一部分图标
          imageSize: new BMap.Size(44, 53), //设置显示图像的大小，因为256*256太大，所以可以设置它实际显示的长宽比例为25.6*25.6，相当于缩小十倍了
          anchor: new BMap.Size(0, 0), //标注指向的地理位置距离图标左上角各偏移13和25.6像素(一般宽度是照片宽的一般，长度是照片的长，这样图标的
          //   尖角就能刚好点在坐标点上，否则是图标的中心点在坐标点上)，本例中该位置即是图标中央下端的尖角位置
        });
        //清除所有标记
        this.map.clearOverlays()
        data.forEach((item, index) => {
          var label = new BMap.Label(index + 1, {
            offset: new BMap.Size(-8, 10),
          });
          label.setStyle({
            background: "none",
            color: "#666",
            border: "none",
            fontSize: "12px",
            width: "60px",
            textAlign: "center",
            margin: "0",
            padding: "0", //只要对label样式进行设置就可达到在标注图标上显示数字的效果
          });
          // var result = gcoord.transform(
          //   [item.LONGITUDE, item.LATITUDE],    // 经纬度坐标
          //   gcoord.WGS84,               // 当前坐标系
          //   gcoord.BD09                 // 目标坐标系
          // );
          // console.log(result,item.LONGITUDE, item.LATITUDE)
          // console.log(gcoord.WGS84)
          // let point = new BMap.Point(Number(item.LONGITUDE), Number(item.LATITUDE));
          // var convertor = new BMap.Convertor();
          // var pointArr = [];
          // pointArr.push(point);
          // convertor.translate(pointArr, 3, 5, function (data) {
          //   console.log(data,index)
          //   if(data.status === 0) {
          //     item.LATITUDE = data.points[0].lat
          //     item.LONGITUDE = data.points[0].lng
          //     // let point = new BMap.Point(data.points[0].lng);
          //     _this.map.centerAndZoom(data.points[0], 12);
          //     let marker = new BMap.Marker(data.points[0], {
          //       icon: type === "server" ? myIcon1 : myIcon2,
          //     });
          //     marker.setLabel(label);
          //     marker.addEventListener("click", function () {
          //       _this.clickEvent(index + 1, item);
          //     });
          //     // marker.editMk = {lng:item.LONGITUDE, lat:item.LATITUDE}
          //     // 创建标注
          //     _this.map.addOverlay(marker);
          //   }
          // })
          let point = new BMap.Point(item.LONGITUDE, item.LATITUDE);
          // this.map.centerAndZoom(point, 12);
          let marker = new BMap.Marker(point, {
            icon: myIcon2,
          });
          marker.setLabel(label);
          marker.addEventListener("click", function () {
            _this.clickEvent(index + 1, item, type);
            _this.buriedPt('ses:list:' + item.name, 'o')
          });
          // marker.editMk = {lng:item.LONGITUDE, lat:item.LATITUDE}
          console.log(marker,888)
          // 创建标注
          this.map.addOverlay(marker);
        });
      }
      if(type === 'search'){
        let data = datas.map(item => {
          // console.log([_this.localInfo.point.lng, _this.localInfo.point.lat],[Number(item.LONGITUDE),Number(item.LATITUDE)])
          item.km = _this.getDistance([_this.localInfo.point.lng, _this.localInfo.point.lat],[item.longitude,item.latitude])
          if(item.latitude){
            return item
          }
        });
        let icon1 = require("../assets/img/icon1.png");
        let icon2 = require("../assets/img/icon2.png");
        var myIcon1 = new BMap.Icon(icon1, new BMap.Size(44, 53), {
          //BMap.Size类表示以指定的宽度和高度创建一个矩形区域大小，有的时候图标太大，Size太小，可能不能显示图标或显示一部分图标
          imageSize: new BMap.Size(44, 53), //设置显示图像的大小，因为256*256太大，所以可以设置它实际显示的长宽比例为25.6*25.6，相当于缩小十倍了
          anchor: new BMap.Size(13, 13), //标注指向的地理位置距离图标左上角各偏移13和25.6像素(一般宽度是照片宽的一般，长度是照片的长，这样图标的
          //   尖角就能刚好点在坐标点上，否则是图标的中心点在坐标点上)，本例中该位置即是图标中央下端的尖角位置
        });
        var myIcon2 = new BMap.Icon(icon2, new BMap.Size(44, 53), {
          //BMap.Size类表示以指定的宽度和高度创建一个矩形区域大小，有的时候图标太大，Size太小，可能不能显示图标或显示一部分图标
          imageSize: new BMap.Size(44, 53), //设置显示图像的大小，因为256*256太大，所以可以设置它实际显示的长宽比例为25.6*25.6，相当于缩小十倍了
          anchor: new BMap.Size(0, 0), //标注指向的地理位置距离图标左上角各偏移13和25.6像素(一般宽度是照片宽的一般，长度是照片的长，这样图标的
          //   尖角就能刚好点在坐标点上，否则是图标的中心点在坐标点上)，本例中该位置即是图标中央下端的尖角位置
        });
        //清除所有标记
        this.map.clearOverlays()
        data.forEach((item, index) => {
          var label = new BMap.Label(index + 1, {
            offset: new BMap.Size(-8, 10),
          });
          label.setStyle({
            background: "none",
            color: "#666",
            border: "none",
            fontSize: "12px",
            width: "60px",
            textAlign: "center",
            margin: "0",
            padding: "0", //只要对label样式进行设置就可达到在标注图标上显示数字的效果
          });
          let point = new BMap.Point(item.longitude,item.latitude);
          // this.map.centerAndZoom(point, 12);
          let marker = new BMap.Marker(point, {
            icon: item.type===2?myIcon2:myIcon1,
          });
          marker.setLabel(label);
          marker.addEventListener("click", function () {
            _this.clickEvent(index + 1, item, type);
            _this.buriedPt('ses:list:' + item.name, 'o')
          });
          // marker.editMk = {lng:item.LONGITUDE, lat:item.LATITUDE}
          // console.log(marker,888)
          // 创建标注
          this.map.addOverlay(marker);
        });
      }
    },
    getDistance(centerPoint, otherPoint) {
        var myP1 = new BMap.Point(centerPoint[0], centerPoint[1]);    //起点
        var myP2 = new BMap.Point(otherPoint[0], otherPoint[1]);    //终点
      var distance = this.map.getDistance(myP1, myP2);
      return (distance / 1000).toFixed(2) + "km";
    },
    //切换城市
    selectCity(city){
      let _this = this
      if(_this.localInfo.address.city.indexOf(city) != -1){
              if(_this.pc){
                if(_this.localInfo.address.city === '北京市'){
                  let point = new BMap.Point(116.48548, 39.9484);
                  // 初始化地图，设置中心点坐标和地图级别
                  _this.map.centerAndZoom(point, 13);
                }else{
                  _this.map.centerAndZoom(city, 13);
                }
              }else{
                let point = new BMap.Point(_this.localInfo.longitude,_this.localInfo.latitude);
                _this.map.centerAndZoom(point, 12);
              }
            }else{
              if(city === '北京'){
                let point = new BMap.Point(116.48548, 39.9484);
              // 初始化地图，设置中心点坐标和地图级别
                _this.map.centerAndZoom(point, 12);
              }else{
                _this.map.centerAndZoom(city, 12);
              }
            }
    },
    //获取当前位置
    getLocation(e) {
      console.log()
      const _this = this;
      _this.fullscreenLoading = true;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        console.log(r);
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          console.log("您的位置：" + r.point.lng + "," + r.point.lat);
          var point = new BMap.Point(r.point.lng, r.point.lat); //用所定位的经纬度查找所在地省市街道等信息

          var gc = new BMap.Geocoder();

          gc.getLocation(point, function (rs) {
            var addComp = rs.addressComponents;
            console.log(rs.address); //地址信息
            console.log(rs); //地址信息
            console.log(r); 
            // document.getElementById("location_info_content").setAttribute("value",rs.address)
            //打开导航页面
            _this.fullscreenLoading = false;
            _this.localInfo = r
            _this.localInfo.addressName = rs.address
            // _this.map.centerAndZoom(_this.localInfo.address.city, 14);
            _this.$refs.mapMenuss.defStoresTheQuery(r.address,r.point)
            if(!_this.out_of_china(r) || (r.address.city === '北京市' && _this.pc)){
            // if(!_this.out_of_china(37.35,55.45)){
              // alert('非国内')
              let point = new BMap.Point(116.48548, 39.9484);
              // 初始化地图，设置中心点坐标和地图级别
              _this.map.centerAndZoom(point, 13);
            }else{
              let point = new BMap.Point(r.longitude,r.latitude);
              _this.map.centerAndZoom(point, 12);
            }
            // if(_this.pc){
            //     window.open(`http://api.map.baidu.com/geocoder?location=${e.LATITUDE},${e.LONGITUDE}&coord_type=gcj02&output=html&src=webapp.baidu.openAPIdemo`)
            //     // baiduNavigate({lnglat:[], city: '北京市', name:'请输入起点'},{lnglat:[116.399120,39.889210], city: '北京市', name:'天坛公园'})
            // }else{
            //     baiduNavigate({lnglat:[r.point.lng,r.point.lat], city: addComp.city, name:rs.address},{lnglat:[e.LONGITUDE,e.LATITUDE], city: e.CITY, name:e.ServiceAddress})
            // }
          });
        } else {
          console.log("failed" + this.getStatus());
        }
      });
    },
    // 判断是否在中国境内 true 是  false 否  判断市是不是中文 来判断是不是在中国
    out_of_china(r) {
        //var lat = lat;
        //var lng = lng;

        // 创建地理编码实例      
//var myGeo = new BMap.Geocoder();      
// 根据坐标得到地址描述    
//myGeo.getLocation(new BMap.Point(lng,lat), function(result){      
    //if (result){      
      //console.log('result',r.address.province);      
     var re= /^[\u4E00-\u9FA5]+$/;
     // console.log('result.address',re.test(r.address.province))
   // }      
//});
        // 纬度3.86~53.55,经度73.66~135.05 
  
        return re.test(r.address.province)
    },
    navigation(e,type) {
        const _this = this
        let r = this.localInfo
        let lat,lng,address,city
        if(type === 'server') {
          lat = e.LATITUDE
          lng = e.LONGITUDE
          address = e.ServiceAddress
          city = e.CITY
        }
        if(type === 'store' || type === 'search') {
          lat = e.latitude
          lng = e.longitude
          address = e.address
          city = e.regionname
        }
        // console.log(e,666)
      if (_this.pc) {
        console.log(`http://api.map.baidu.com/marker?location=${lat},${lng}&title=我的位置&content=${address}&output=html&src=webapp.baidu.openAPIdemo`)
        window.open(
          `http://api.map.baidu.com/marker?location=${lat},${lng}&title=我的位置&content=${address}&output=html&src=webapp.baidu.openAPIdemo`
          // `http://api.map.baidu.com/geocoder?location=${e.LATITUDE},${e.LONGITUDE}&coord_type=gcj02&output=html&src=webapp.baidu.openAPIdemo`
        );
        // baiduNavigate({lnglat:[], city: '北京市', name:'请输入起点'},{lnglat:[116.399120,39.889210], city: '北京市', name:'天坛公园'})
      } else {
        // baiduNavigate({lnglat:[r.point.lng, r.point.lat], city:r.address.city, name:r.addressName},{lnglat: [lng, lat], city: '北京市', name:address})

        console.log({
            lnglat: [r.point.lng, r.point.lat],
            city: r.address.city,
            name: r.addressName,
          },
          {
            lnglat: [lng, lat],
            city: city,
            name: address,
          })
        baiduNavigate(
          {
            lnglat: [r.point.lng, r.point.lat],
            city: r.address.city,
            name: r.addressName,
          },
          {
            lnglat: [lng, lat],
            city: city,
            name: address,
          }
        );
      }
    },
    checkStore(e, type) {
      let point
      if(type === 'server') {
        point = new BMap.Point(e.LONGITUDE, e.LATITUDE)
      }
      if(type === 'store' || type === 'search') {
        point = new BMap.Point(e.longitude, e.latitude)
      }
      // let point = new BMap.Point(e.LONGITUDE, e.LATITUDE);
      this.map.centerAndZoom(point, 18);
    },
    tabSwitch(e) {
      this.infoWindowState = false;
      // this.map.clearOverlays()
    },
    closeWin(e) {
      this.infoWindowState = false;
    },
    clickEvent(index, data, type) {
      // alert(data)
      this.infoWindowData = data;
      this.infoWindowData.dataIndex = index;
      this.infoWindowData.tabType = type;
      this.infoWindowState = true;
    },
    bodyCloseMenus(e) {
      let tree = document.querySelector(".main");
      console.log(tree, 4);
      // console.log(tree.contains(e.target),4)
      // console.log(e.target,4)
      if (tree) {
        if (this.pc) {
          // 判断鼠标点击的区域是否在tree里面，否则关闭弹窗
          if (!tree.contains(e.target)) {
            // console.log(this.infoWindowState,5)

            if (this.infoWindowState == true) {
              this.infoWindowState = false;
            }
          }
        } else {
          if (this.infoWindowState == true) {
            this.infoWindowState = false;
          }
        }
      }
      if (!this.pc) {
        this.$refs.mapMenuss.closeselect();
      }
    },
    buriedPt(parame1, parame2) {
      console.log(parame1, parame2,'/************/')
      LinkClick(parame1,parame2)
    }
  },
  beforeDestroy() {
    if (this.pc) {
      // document.removeEventListener("mouseup", this.bodyCloseMenus);
    } else {
      this.map.removeEventListener("touchstart", this.bodyCloseMenus);
      document
        .getElementById("app")
        .removeEventListener("mouseup", this.bodyCloseMenus);
    }
  },
};
</script>

<style scoped lang="scss">
.home{
  position:relative;
  width: 100%;
  height: 100vh;
  min-height: 500px;
}
.map {
  width: 100%;
  height: 100vh;
  min-height: 500px;
}
.menuP {
  max-width: 400px;
  min-width: 400px;
  max-height: 90vh;
  min-height: 60px;
  position: absolute;
  top: 22px;
  left: 22px;
  background-color: #fff;
  z-index: 999;
  // overflow-y: auto;
}
// .menuP::-webkit-scrollbar { width: 0 !important }
.menuM {
  width: 100vw;
  max-height: 100vh;
  min-height: 105px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0;
  margin: 0;
  // overflow-y: auto;
}

</style>